<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  @if (type === 'Add') {
    <div i18n="@@buySubscription">Buy New Subscription</div>
  }
  @if (type !== 'Add') {
    <div i18n="@@editSubscription">Edit Subscription</div>
  }
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="addSubscriptionForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline" style="display: none">
        <mat-label i18n="@@subscriptions">Subscriptions</mat-label>
        <mat-chip-grid #chipList>
          @for (code of codes; track code; let index = $index) {
            <mat-chip-row
              [selected]="code.state"
              [removable]="removable"
              (click)="onChipClick(index)"
              (removed)="remove(code)">
              {{code.firstName}} {{code.lastName}}
              @if (removable) {
                <mat-icon matChipRemove i18n-aria-label aria-label="Remove">cancel</mat-icon>
              }
            </mat-chip-row>
          }
        </mat-chip-grid>
        <input
          disabled
          placeholder="Subscriptions"
          i18n-placeholder="@@subscriptionsPlaceholder"
          [matChipInputFor]="chipList">
      </mat-form-field>
      <div class="d-flex">
        <mat-form-field class="w-50 mr-8" appearance="outline">
          <mat-label i18n="@@firstNameLabel">First name</mat-label>
          <input data-testid="firstName" matInput id="firstName" i18n-placeholder="@@firstNamePlaceholder" placeholder="First name" name="firstName" formControlName="firstName" required />
          <mat-error>
            @if (!addSubscriptionForm.get('firstName').valid && addSubscriptionForm.get('firstName').touched) {
              @if (addSubscriptionForm.get('firstName').errors && addSubscriptionForm.get('firstName').errors['required'] || addSubscriptionForm.get('firstName').hasError('whitespace')) {
                <span i18n="@@inValidRequiredField">This field is required</span>
              }
            }
          </mat-error>
        </mat-form-field>
        <mat-form-field class="w-50" appearance="outline">
          <mat-label i18n="@@lastNameLabel">Last name</mat-label>
          <input data-testid="lastName" matInput id="lastName" i18n-placeholder="@@lastNamePlaceholder" placeholder="Last name" name="lastName" formControlName="lastName" required />
          <mat-error>
            @if (!addSubscriptionForm.get('lastName').valid && addSubscriptionForm.get('lastName').touched) {
              @if (addSubscriptionForm.get('lastName').errors && addSubscriptionForm.get('lastName').errors['required'] || addSubscriptionForm.get('lastName').hasError('whitespace')) {
                <span i18n="@@inValidRequiredField">This field is required</span>
              }
            }
          </mat-error>
        </mat-form-field>
      </div>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@emailLabel">Email</mat-label>
        <input (ngModelChange)="checkEmail()" data-testid="email" matInput id="email" placeholder="Email" i18n-placeholder="@@emailPlaceholder"  name="email" formControlName="email" required />
        <mat-error>
          @if (!addSubscriptionForm.get('email').valid && addSubscriptionForm.get('email').touched) {
            @if (addSubscriptionForm.get('email').errors && addSubscriptionForm.get('email').errors['required']) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
          @if (addSubscriptionForm.get('email').errors && !addSubscriptionForm.get('email').errors['required'] && addSubscriptionForm.get('email').errors['emailNotValid']) {
            <span i18n="@@inValidEmail">Please enter a valid email</span>
          }
          @if (addSubscriptionForm.get('email').errors && !addSubscriptionForm.get('email').errors['required'] && addSubscriptionForm.get('email').errors['used']) {
            <span i18n="@@usedEmail">This email is used!</span>
          }
        </mat-error>
      </mat-form-field>
      <div class="form-group d-flex">
        <mat-form-field style="width: 32%" appearance="outline">
          <mat-label i18n="@@countryCodeLabel">Country code</mat-label>
          <input (keypress)="numberOnly($event)" data-testid="country_code" matInput id="country_code" placeholder="001" i18n-placeholder="@@countryCodePlaceholder" name="country_code" formControlName="country_code" required />
          <mat-error>
            @if (!addSubscriptionForm.get('country_code').valid && addSubscriptionForm.get('country_code').touched) {
              @if (addSubscriptionForm.get('country_code').errors && addSubscriptionForm.get('country_code').errors['required']) {
                <span i18n="@@inValidRequiredField">Required</span>
              }
            }
            @if (addSubscriptionForm.get('country_code').errors && addSubscriptionForm.get('country_code').errors['maxlength'] && !addSubscriptionForm.get('country_code').errors['required']) {
              <span i18n="@@invalid_country_code_format">Max. 5 digits</span>
            }
          </mat-error>
        </mat-form-field>
        <mat-form-field class="flex-grow ml-8" appearance="outline">
          <mat-label i18n="@@phoneNumberLabel">Phone number</mat-label>
          <input (keypress)="numberOnly($event)" data-testid="phone_number" matInput id="phone_number" i18n-placeholder="@@phoneNumberPlaceholder" placeholder="Phone number" name="phone_number" formControlName="phone_number" required />
          <mat-error>
            @if (!addSubscriptionForm.get('phone_number').valid && addSubscriptionForm.get('phone_number').touched) {
              @if (addSubscriptionForm.get('phone_number').errors && addSubscriptionForm.get('phone_number').errors['required']) {
                <span i18n="@@inValidRequiredField">This field is required</span>
              }
            }
            @if (addSubscriptionForm.get('phone_number').errors && addSubscriptionForm.get('phone_number').errors['minlength'] && !addSubscriptionForm.get('phone_number').errors['required']) {
              <span i18n="@@invalid_phone_min_length">Please enter 7 digits minimum</span>
            }
            @if (addSubscriptionForm.get('phone_number').errors && addSubscriptionForm.get('phone_number').errors['maxlength'] && !addSubscriptionForm.get('phone_number').errors['required']) {
              <span i18n="@@invalid_phone_max_length">Please enter 14 digits maximum</span>
            }
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-group">
        @if (type === 'Edit') {
          <mat-form-field class="w-100" appearance="outline">
            <mat-label i18n="@@passwordLabel">Password</mat-label>
            <input data-testid="add_edit_subscription_password"  #password_edit [type]="hide ? 'password' : 'text'" matInput id="password_edit" i18n-placeholder="@@passwordPlaceholder" placeholder="Password" name="password_edit" formControlName="password_edit" />
            <mat-icon class="cursor" matSuffix (click)="hide = !hide" i18n-aria-label [attr.aria-label]="hide ? 'Show password' : 'Hide password'">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
            <mat-hint align="end" [class]="meterMessage" >
              {{meterMessage}}
            </mat-hint>
            <mat-error>
              @if (addSubscriptionForm.get('password_edit').errors && addSubscriptionForm.get('password_edit').errors['pattern']) {
                <span i18n="@@inValidPassword">Password should be at least 8 alphanumeric characters!</span>
              }
            </mat-error>
          </mat-form-field>
        }
        @if (type === 'Add') {
          <mat-form-field class="w-100" appearance="outline">
            <mat-label i18n="@@passwordLabel">Password</mat-label>
            <input data-testid="add_edit_subscription_password"  #password_add [type]="hide ? 'password' : 'text'" matInput id="password_add" i18n-placeholder="@@passwordPlaceholder" placeholder="Password" name="password_add" formControlName="password_add" required />
            <mat-icon class="cursor" matSuffix (click)="hide = !hide" i18n-aria-label [attr.aria-label]="hide ? 'Show password' : 'Hide password'">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
            <mat-hint align="end" [class]="meterMessage" >
              {{meterMessage}}
            </mat-hint>
            <mat-error>
              @if (!addSubscriptionForm.get('password_add').valid && addSubscriptionForm.get('password_add').touched) {
                @if (addSubscriptionForm.get('password_add').errors['required']) {
                  <span i18n="@@inValidRequiredField">This field is required</span>
                }
              }
              @if (addSubscriptionForm.get('password_add').errors && addSubscriptionForm.get('password_add').errors['pattern']) {
                <span i18n="@@inValidPassword">Password should be at least 8 alphanumeric characters!</span>
              }
            </mat-error>
          </mat-form-field>
        }
      </div>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@promotionCodeLabel">Promotion code</mat-label>
        <input data-testid="promotion_code" matInput id="promotion_code" i18n-placeholder="@@promotionCodePlaceholder" placeholder="Promotion code" name="promotion_code" formControlName="promotion_code" required/>
        <mat-error>
          @if (!addSubscriptionForm.get('promotion_code').valid && addSubscriptionForm.get('promotion_code').touched) {
            @if (addSubscriptionForm.get('promotion_code').errors && addSubscriptionForm.get('promotion_code').errors['required']) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>
    <div class="d-flex">
      @if (selected === null && type === 'Add') {
        <button i18n="@@addAnother" data-testid="add_another_subscription" class="w-50 mr-8" mat-raised-button color="primary" (click)="addAnother()">Add Another</button>
      }
      @if (selected !== null && type === 'Add') {
        <button i18n="@@edit" data-testid="edit_subscription" class="w-50 mr-8" mat-raised-button color="primary" (click)="editSubscription()">Edit</button>
      }
      @if (type === 'Add') {
        <button i18n="@@done" data-testid="add_subscription" class="w-50 ml-8" mat-raised-button color="primary" (click)="onSubmit()">Done</button>
      }
      @if (type === 'Edit') {
        <button i18n="@@edit" data-testid="add_subscription" class="w-100 ml-8" mat-raised-button color="primary" (click)="onEdit()">Edit</button>
      }
    </div>
  </form>
</mat-dialog-content>